"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataLayer = exports.EcommerceEvent = void 0;
if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
}
var EcommerceEvent;
(function (EcommerceEvent) {
    EcommerceEvent["view_item"] = "view_item";
    EcommerceEvent["view_item_list"] = "view_item_list";
    EcommerceEvent["select_item"] = "select_item";
    EcommerceEvent["begin_checkout"] = "begin_checkout";
    EcommerceEvent["add_payment_info"] = "add_payment_info";
    EcommerceEvent["add_shipping_info"] = "add_shipping_info";
    EcommerceEvent["purchase"] = "purchase";
})(EcommerceEvent = exports.EcommerceEvent || (exports.EcommerceEvent = {}));
// Adds custom dimension if sent in a particular event, if not default to empty string. This
// prevents a data layer issue where an unfilled dimensions takes a filled value from a recent event
const fillCustomDimensions = (props) => {
    return {
        event_name: (props === null || props === void 0 ? void 0 : props.eventName) || '',
        event_type: (props === null || props === void 0 ? void 0 : props.eventType) || '',
        form_field: (props === null || props === void 0 ? void 0 : props.formField) || '',
        form_message: (props === null || props === void 0 ? void 0 : props.formMessage) || '',
        section: (props === null || props === void 0 ? void 0 : props.section) || '',
        customer_id: (props === null || props === void 0 ? void 0 : props.customerId) || '',
        policy_type: (props === null || props === void 0 ? void 0 : props.policyType) || '',
        make: (props === null || props === void 0 ? void 0 : props.make) || '',
        member_id: (props === null || props === void 0 ? void 0 : props.memberId) || '',
        payment_journey: (props === null || props === void 0 ? void 0 : props.paymentJourney) || '',
        policy_reference: (props === null || props === void 0 ? void 0 : props.policyReference) || '',
        ecommerce: (props === null || props === void 0 ? void 0 : props.ecommerce) || {},
    };
};
exports.DataLayer = {
    customEvent: (props) => window === null || window === void 0 ? void 0 : window.dataLayer.push(Object.assign({ event: 'visitor interaction', interaction_name: 'custom event' }, fillCustomDimensions(props))),
    customEcommerceEvent: ({ event, ecommerce, section = '' }) => window === null || window === void 0 ? void 0 : window.dataLayer.push(Object.assign({ event, interaction_name: 'custom event' }, fillCustomDimensions({ ecommerce, section }))),
};
